<template>
  <panel :heading="label">
    <template v-if="!activated">
      <div class="heading">
        Activate your account with a valid Iowa driver's license or an activation code.
      </div>
      <license-code />
    </template>
    <span v-else>Welcome to {{ $store.getters['app/appName'] }}!</span>
  </panel>
</template>
<script>
import LicenseCode from '@components/singletons/licenseCode';
import Panel from '@components/singletons/panel';

export default {
  components: { LicenseCode, Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    activated() {
      return this.$store.getters['session/hasPaid'];
    },
  },
};
</script>
<style lang='scss' scoped>
:deep(.activation-component-container) {
  flex-basis: 100%;
}

:deep(.license-heading) {
  display: none;
}

.heading {
  font-size: rem-calc(14);
  margin-bottom: rem-calc(8);
}
</style>
